import {
  SlFormatNumber
} from "./chunk.R7YK2T4U.js";

// src/components/format-number/format-number.ts
var format_number_default = SlFormatNumber;
SlFormatNumber.define("sl-format-number");

export {
  format_number_default
};
